export const supportedCharacters = 'abcdefghijklmnopqrstuvwxyz_';
export const supportedCharactersArr = supportedCharacters.split('');
